import { useState, type FormEvent } from "react";
import { api } from "../api.js";
import type { Me } from "../types.js";

export default function Login({ onSignedIn }: { onSignedIn: (me: Me) => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onSignedIn(await api.post<Me>("/api/auth/login", { email, password }));
    } catch (err) {
      setError(err instanceof Error ? err.message : "Anmeldung fehlgeschlagen");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <form className="login-card" onSubmit={submit}>
        <div className="brand-header">
          <img src="/airjet-logo.svg" alt="AirJet" className="brand-logo brand-logo-lg" />
        </div>

        {error && <div className="err" role="alert">{error}</div>}

        <div className="field">
          <label htmlFor="email">Benutzerkonto</label>
          <input id="email" type="email" autoComplete="username" required
                 value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="field">
          <label htmlFor="pw">Passwort</label>
          <input id="pw" type="password" autoComplete="current-password" required
                 value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>

        <button className="btn pri" type="submit" disabled={busy}
                style={{ width: "100%", justifyContent: "center", marginTop: 6 }}>
          {busy ? "Wird geprüft…" : "Anmelden"}
        </button>
      </form>
    </div>
  );
}
